const PREFIX = 'uf/amplitude';

export const INITIALIZE = `${PREFIX}/INITIALIZE`;
